(function() {

    // Form Container - Analytics JS File
    const NS = "cmp";
    const IS = "formContainer";

    const selectors = {
        self: "[data-" + NS + '-is="' + IS + '"]'
    };

    async function digestMessage(message) {
      const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
      const hashBuffer = await window.crypto.subtle.digest("SHA-256", msgUint8); // hash the message
      const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
      const hashHex = hashArray
        .map((b) => b.toString(16).padStart(2, "0"))
        .join(""); // convert bytes to hex string
      return hashHex;
    }

    let dataLayerEnabled;
    let dataLayer;

    function onDocumentReady() {
        dataLayerEnabled = document.body.hasAttribute("data-cmp-data-layer-enabled");
        dataLayer = (dataLayerEnabled) ? window.adobeDataLayer = window.adobeDataLayer || [] : undefined;

        // Query document for all components with the class matching the selector
        const elements = document.querySelectorAll(selectors.self);
        elements.forEach(container => {

            // Form container page load event handler - Fires as part of this onDocumentReady function
            adobeDataLayer.push({
                event:'form_loaded',
                event_info: {
                    form_name: container.getAttribute('name'),
                    form_type: container.getAttribute('data-actiontype')
                }
            });

            // Form container submit event handler - captures submit event from form button component
            const submitEvent = e => {

                //check form has a captcha field, and a valid response is submitted
                const recaptchaEl = container.querySelector('.cheerios-recaptcha');
                let captchaExists = recaptchaEl != null ? true : false;
                let captchaValid = false;
                if(captchaExists){
                    const captchaSuccessResponse = recaptchaEl.getAttribute('data-captcha-response');
                    if ((captchaSuccessResponse != null) && (captchaSuccessResponse != "")) {
                        captchaValid = true;
                    }
                }

                if(captchaValid || !captchaExists) {
                    adobeDataLayer.push({
                        event: 'form_confirmation',
                        event_info: {
                            form_name: container.getAttribute('name'),
                            form_type: container.getAttribute('data-actiontype')
                        }
                    });

                    // hash email to send to data layer
                    var emailName = document.querySelector('.cmp-form input[type="email"]');
                    if ( emailName ) {
                        var emailID = emailName.getAttribute('id');
                        var emailValue = document.getElementById(emailID).value;
                        digestMessage(emailValue).then((digestHex) => localStorage.setItem('em_ci', '{“em_customerid”: ' + digestHex + '}'));
                    } 
                }
            };

            const focusEvent = e => {
                if ( !container.dataset.hadFocus ) {
                    adobeDataLayer.push({
                        event: 'form_focused',
                        event_info: {
                            form_name: container.getAttribute('name'),
                            form_type: container.getAttribute('data-actiontype')
                        }
                    });
                }
                container.dataset.hadFocus = true;
            };

            //Event listeners
            container.addEventListener('submit', submitEvent);
            container.addEventListener('blur', focusEvent, true);
        });
    }

    if (document.readyState !== "loading") {
        onDocumentReady();
    } else {
        document.addEventListener("DOMContentLoaded", onDocumentReady);
    }

})();
